import { Component, inject, input, type OnInit, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { filter } from 'rxjs/operators';
import type { RailBarRouteItemType } from './rail-bar-route-item.type';
import { RailButtonComponent } from './rail-button.component';
@Component({
  selector: 'dtis-rail-navbar',
  imports: [RouterModule, TranslocoModule, MatIconModule, MatButtonModule, RailButtonComponent],
  templateUrl: './rail-navbar.component.html',
  host: {
    class: 'border-outlineVariant bg-surface block h-full border-r print:hidden',
    '[class.rail-navbar--expanded]': 'expanded$()',
    '[class.rail-navbar--collapsed]': '!expanded$()',
  },
  styles: [
    `
      :host {
        transition: width 0.1s ease, min-width 0.1s ease, max-width 0.1s ease;
      }

      :host.rail-navbar--expanded {
        min-width: 360px;
        width: 15%;
        max-width: 15%;
        background-color: var(--surface-container-low-color, #f6f6f6);
        border-radius: 16px;
      }

      :host.rail-navbar--collapsed {
        width: 88px;
        max-width: 88px;
      }

      :host.rail-navbar--expanded #menu {
        padding-left: 18px;
      }
    `,
  ],
})
export class DtisRailNavbarComponent implements OnInit {
  /**
   * Signal that emits the state of the sidebar expansion.
   */
  private readonly router = inject(Router);
  /**
   * Signal that emits the routes for the rail bar.
   */
  routes = input<RailBarRouteItemType[]>([]);
  /**
   * Signal that emits the state of the sidebar expansion.
   * It selects the `isSidebarExpanded` property from the `SettingsState`.
   */
  expanded$ = signal<boolean>(false);
  /**
   * This method toggles the sidebar expansion state.
   */
  ngOnInit(): void {
    this.router.events.pipe(filter((d) => d instanceof NavigationEnd && this.expanded$())).subscribe(() => {
      this.toggleSidebar();
    });
  }

  /**
   * Toggles the sidebar expansion state.
   */
  toggleSidebar() {
    this.expanded$.set(!this.expanded$());
  }
}
